import { render } from "./shinsei_Zangyoedit.vue?vue&type=template&id=5d85614c&scoped=true&ts=true"
import script from "./shinsei_Zangyoedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Zangyoedit.vue?vue&type=script&lang=ts"

import "./shinsei_Zangyoedit.vue?vue&type=style&index=0&id=5d85614c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d85614c"]])

export default __exports__